import { Button } from '@primer/react';
import { Flash } from '@upright/ui/common/generic/components/primer-custom/flash';
import { ReceiptCrossStreamlineCore } from '@upright/ui/icons';
import { useRetryPublishIprProductSet } from './hooks/use-retry-publish-ipr-product-set';
import { sleep } from '@upright/common/utils';
import { FREEMIUM_DMA_RESULT_BANNER_ID } from './with-calculating-results-banner';

interface Props {
  jobId?: number;
  className?: string;
  refetchJobStatus: () => void;
}

export function CalculatingResultsErrorBanner(props: Props) {
  const retryMutation = useRetryPublishIprProductSet();

  const handleRetry = async () => {
    if (props.jobId) {
      await retryMutation.mutateAsync(props.jobId);
      await sleep(1_000);
      props.refetchJobStatus();
    }
  };

  const isRetrying = retryMutation.isPending || retryMutation.isSuccess;

  return (
    <Flash
      title="Results failed to update"
      icon={<ReceiptCrossStreamlineCore />}
      variant="danger"
      dismissable={true}
      className={props.className}
      flashIdForDismissalTracking={FREEMIUM_DMA_RESULT_BANNER_ID}
    >
      Results failed to update due to an unexpected error. If the problem persists, please contact support.
      {props.jobId && (
        <>
          {' '}
          <Button
            variant="primary"
            style={{ marginLeft: '1.0em' }}
            size="small"
            onClick={() => void handleRetry()}
            disabled={retryMutation.isPending}
          >
            {isRetrying ? 'Retrying...' : 'Retry'}
          </Button>
        </>
      )}
    </Flash>
  );
}
